import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import BusinessDisplaying from './pages/BusinessDisplaying';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Home from './pages/Home';
import Login from './pages/Login';
import SecurityQuestions from './pages/SecurityQuestions';
import AccountType from './pages/AccountType';
import AccountRecovery from './pages/AccountRecovery';
import PasswordReset from './pages/PasswordReset';
import Manage from './pages/Manage';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/business/:accountId/:businessName" element={<BusinessDisplaying />} />
    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register/security-questions" element={<SecurityQuestions />} />
    <Route path="/register/account-type" element={<AccountType />} />
    <Route path="/account-recovery" element={<AccountRecovery />} />
    <Route path="/account-recovery/verify" element={<SecurityQuestions />} />
    <Route path="/account-recovery/reset-password" element={<PasswordReset />} />
    <Route
      path="/manage"
      element={
        <ProtectedRoute>
          <Manage />
        </ProtectedRoute>
      }
    />
  </Routes>
);

const App = () => (
  <Router>
    <ThemeProvider>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </ThemeProvider>
  </Router>
);

export default App;
